import { Button, Form, Input } from 'antd';
import { KenyanMobileInput } from '../../../../../shared/components/KenyanMobileInput';
import { kenyanMobileRules } from '../../../../../shared/policies/kenyan-mobile-rules';
import { CONTACT_COPY, type ContactKind } from '../policies/contact-change';

interface NewContactFormProps {
  kind: ContactKind;
  submitting: boolean;
  onSend: (value: string) => void;
  onCancel: () => void;
}

const EMAIL_RULES = [{ required: true, type: 'email' as const, message: 'Enter an email address' }];

/** The first step of a change: the new email or mobile, and "Send a code" to it. */
export function NewContactForm({ kind, submitting, onSend, onCancel }: NewContactFormProps) {
  const isEmail = kind === 'email';
  return (
    <Form<{ value: string }> layout="vertical" requiredMark={false} onFinish={(values) => onSend(values.value)} disabled={submitting}>
      <Form.Item
        name="value"
        label={CONTACT_COPY[kind].fieldLabel}
        rules={isEmail ? EMAIL_RULES : kenyanMobileRules({ required: true, requiredMessage: 'Enter a mobile number' })}
      >
        {isEmail ? <Input type="email" autoComplete="email" autoFocus /> : <KenyanMobileInput autoFocus />}
      </Form.Item>
      <div className="flex gap-2">
        <Button type="primary" htmlType="submit" loading={submitting}>
          Send a code
        </Button>
        <Button onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
      </div>
    </Form>
  );
}
